export const isBeyond12Months = dateString => {
  if (!dateString) return false; // if dateString is null, undefined or an empty string

  const givenDate = new Date(dateString);

  if (isNaN(givenDate)) return false; // if givenDate is an invalid date

  const currentDate = new Date();

  // calculating the difference in months
  let monthsDifference = (currentDate.getFullYear() - givenDate.getFullYear()) * 12;
  monthsDifference -= givenDate.getMonth();
  monthsDifference += currentDate.getMonth();

  return monthsDifference >= 12;
};
